<template>
  <svg width="25px" height="12px" viewBox="0 0 25 12" version="1.1" xmlns="http://www.w3.org/2000/svg"
       xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="common-symbols/matero-station/gray" transform="translate(0.000000, 1.000000)"
         fill-rule="nonzero">
        <g id="Group-2">
          <path :fill="'#'+stationColor"
                d="M0,5 L0,5 C6.76353751e-17,5.55228475 0.44771525,6 1,6 L24,6 C24.5522847,6 25,5.55228475 25,5 L25,5 C25,4.44771525 24.5522847,4 24,4 L1,4 C0.44771525,4 -6.76353751e-17,4.44771525 0,5 Z"
                id="Path">
          </path>
          <circle id="Oval" :stroke="'#'+stationColor" fill="transparent" cx="13"
                  cy="5" r="5"></circle>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "metroIcon",
  props: {
    stationColor: {
      type: String,
      default: ()=> '#A5A5A5'
    }
  }
}
</script>

<style scoped>

</style>
